import { ChangeDetectionStrategy, Component } from '@angular/core';

@Component({
  selector: 'wen-icon-staking',
  templateUrl: './staking.component.html',
  styleUrls: ['./staking.component.less'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class StakingIconComponent {}
